import { ApproveDialogView, InboxView, ReasonDialogView } from '@today/ui-domain'
import { useInbox } from '@/hooks/content/useInbox'

/** `/content/inbox` — the approval inbox (TO-420 content-admin-ui REQ-008). */
export function InboxPage() {
	const inbox = useInbox()
	return (
		<>
			<InboxView {...inbox.view} />
			<ApproveDialogView {...inbox.approve} />
			<ReasonDialogView {...inbox.reason} />
		</>
	)
}
